import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import { AuthenticatedExternalUserRoutes } from "_constants/PageRoutes";
import { SubscriptionStatus, SubscriptionType } from "_constants/SubscriptionConstants";
import MCSConfirmDialog from "components/MCSConfirmDialog";
import MCSOverlayLoading from 'components/MCSOverlayLoading';
import MCSSpace from 'components/MCSSpace';
import OrderReferenceAccordion from "components/order/OrderReferenceAccordion";
import CancelSubsciptionFormControl from "components/subscription/CancelSubsciptionFormControl";
import CancellationReferenceAccordion from "components/subscription/CancellationReferenceAccordion";
import SubscriptionInformationList from "components/subscription/SubscriptionInformationList";
import { GlobalAlertContext } from 'context/GlobalAlertContext';
import ErrorPage from "pages/Error/ErrorPage";
import React, { useContext, useState } from 'react';
import { useForm } from "react-hook-form";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory, useLocation } from "react-router-dom";
import { SubscriptionApi } from 'services/subscription.service';

const SubscriptionDetails = () => {
    const alertContext = useContext(GlobalAlertContext);
    const location = useLocation();
    const history = useHistory();
    const { promiseInProgress } = usePromiseTracker();
    const [error, setError] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [showCancelSubscriptionForm, setShowCancelSubscriptionForm] = useState(false);
    const [showCancelReferenceSection, setShowCancelReferenceSection] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(null);
    const { control, handleSubmit, setFormError, getValues, setValue } = useForm();
    const [formData, setFormData] = useState(getValues());
    const updateFormData = () => setFormData(getValues());

    function returnToViewSubscription() {
        history.push(AuthenticatedExternalUserRoutes.SUBSCRIPTIONS);
    }

    const fetchData = (id) => {
        trackPromise(
            SubscriptionApi.GetSubscription(id)
                .then(result => {
                    let tempSub = result.data;
                    setSubscription(tempSub);
                    setFormData({ ...formData, subscription: tempSub });
                    updateFormState(tempSub);
                })
                .catch(error => {
                    setError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    function updateFormState(subscription) {
        let showCancelForm = subscription != null
            && subscription.subscriptionType === SubscriptionType.Recurring
            && subscription.subscriptionStatus === SubscriptionStatus.Active;

        setShowCancelSubscriptionForm(showCancelForm);

        let showCancelReference = subscription != null
            && subscription.subscriptionType === SubscriptionType.Recurring
            && subscription.subscriptionStatus === SubscriptionStatus.Cancelled;

        setShowCancelReferenceSection(showCancelReference);
    }

    React.useEffect(() => {
        if (location.state != null && location.state.subscriptionId != null) {
            fetchData(location.state.subscriptionId);
        } else {
            returnToViewSubscription();
        }
    }, []);

    const beforeSubmit = () => {
        setConfirmDialog({
            ...confirmDialog,
            title: "Confirm",
            type: "warning",
            message: "Do you wish to cancel the Subscription?",
            open: true,
            id: "cancel-subscription",
        });
    }

    const cancelConfirmHandler = (data) => {
        let subscriptionCancelDto = {
            id: subscription.id,
            cancellationReason: formData.subscription.cancellationReason
        };

        trackPromise(
            SubscriptionApi.CancelSubscription(subscriptionCancelDto)
                .then((result) => {
                    if (!result.data) {
                        alertContext.setErrorMessage(result.data.error.message);
                    } else {
                        var response = result.data;
                        if (response.success) {
                            alertContext.setSuccessMessage("Subscription has been canceled!");
                            returnToViewSubscription();
                        } else {
                            alertContext.setErrorMessage(response.error.message);
                        }
                    }
                })
                .catch((error) => {
                    alertContext.setErrorMessage("Failed to cancel the Subscription");
                })
        );
    };

    if (error) {
        return <ErrorPage text={error.message} />;
    }

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {(alertObj) => (
                    <>
                        {confirmDialog && (
                            <MCSConfirmDialog
                                alertObj={alertObj}
                                confirmHandler={cancelConfirmHandler}
                                confirmDialog={confirmDialog}
                                setConfirmDialog={setConfirmDialog}
                            />
                        )}
                        <Grid>
                            {subscription &&
                                <>
                                    <Row>
                                        <Col>
                                            <SubscriptionInformationList subscription={subscription} fetchData={fetchData}/>
                                            {showCancelSubscriptionForm &&
                                                <CancelSubsciptionFormControl control={control} subscription={subscription} updateFormData={updateFormData} />}
                                        </Col>
                                    </Row><Row>
                                        <Col>
                                            {showCancelReferenceSection &&
                                                <CancellationReferenceAccordion subscription={subscription} />}
                                            {!showCancelReferenceSection &&
                                                <OrderReferenceAccordion order={subscription.order} />}
                                        </Col>
                                    </Row>
                                    <MCSSpace />
                                    <Row>
                                        <Col>
                                            <ButtonGroup direction="right">
                                                <ButtonText colorScheme="secondary" onClick={returnToViewSubscription}>Back</ButtonText>
                                                {showCancelSubscriptionForm &&
                                                    <ButtonText colorScheme="primary" onClick={handleSubmit(beforeSubmit)}>Cancel Subscription</ButtonText>
                                                }
                                            </ButtonGroup>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Grid>
                    </>)}
            </GlobalAlertContext.Consumer>
        </>
    );
}


export default SubscriptionDetails;
